import type { I18nFn } from '#/i18n/types/I18nFn';
import type { I18nLocale } from '#/i18n/types/I18nLocale';

import { COUNTRIES } from './constants/general/countries';
import { LOCALE_NAMES } from './constants/general/locales';
import { US_STATES } from './constants/general/usStates';
import { invariant } from './invariant';

export function getLocaleName(localeId: I18nLocale) {
  const localeName = LOCALE_NAMES[localeId];
  invariant(localeName, `Invalid locale ID: ${localeId}`);
  return localeName;
}

export function getCountryName(i18n: I18nFn, countryId: string) {
  const country = COUNTRIES(i18n).find(({ id }) => id === countryId);
  if (country) return country.name;
  return '';
}

export function getUsStateName(i18n: I18nFn, stateId: string) {
  const state = US_STATES(i18n).find(({ id }) => id === stateId);
  if (state) return state.name;
  return '';
}
